import { IRemoteRefreshSchedule } from '../types/IRemoteRefreshSchedule';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateRemoteRefreshScheduleParams {
  targetId: string;
  initial:  IRemoteRefreshSchedule;
  final:  IRemoteRefreshSchedule;
}

export class UpdateRemoteRefreshScheduleRequest extends Request<IUpdateRemoteRefreshScheduleParams, IResult> {
  constructor(params: IUpdateRemoteRefreshScheduleParams) {
    super('updateRemoteRefreshSchedule', params);
  }
}
